{
  "hero": {
    "title": "CGI Philippines — ITS JumpStart",
    "description": "ITS JumpStart is our fast-track engagement to get business leaders from data sources → trusted pipelines → decision-ready dashboards → AI pilots in weeks, not months. It bundles discovery, technical setup, governance, and enablement into a clear path to value—designed for rapid, low-risk starts.",
    "heroImage": "/assets/img/hero-image.png",
    "heroImageAlt": "ITS Team"
  },
  "nav": [
    {
      "name": "About ITS",
      "href": "/about/about-its/"
    },
    {
      "name": "Members",
      "href": "/about/members/"
    },
    {
      "name": "Contact Us",
      "href": "/about/contact-us/"
    }
  ],
  "aboutDAS": {
    "title": "About ITS",
    "description": "Distilled experience from 50+ engagements. We bring the people, patterns, and platforms to accelerate your data journey.",
    "stats": [
      {
        "label": "Clients Onboarded",
        "value": "20+"
      },
      {
        "label": "Days to 1st Dashboard",
        "value": "10–30"
      },
      {
        "label": "Data Sources Integrated",
        "value": "15+"
      },
      {
        "label": "Practitioners",
        "value": "30+"
      }
    ],
    "playbook": {
      "title": "Engagement Playbook",
      "description": "Engagements follow a concise playbook: discovery workshops, KPI cataloguing, secure landing zone, ELT/ETL pipelines, semantic modeling, dashboard patterns, and lightweight governance. We enable client teams with documentation, hand-off runbooks, and office hours to keep momentum beyond the pilot.",
      "items": [
        {
          "title": "Discovery & KPI Catalog",
          "description": "Facilitated workshops to align goals, define critical metrics, and map decisions to the data that supports them.",
          "to": "/jumpstart/discovery",
          "cta": "View Agenda",
          "tone": "crimson",
          "icon": "Folder"
        },
        {
          "title": "Data Landing Zone & Pipelines",
          "description": "Secure foundations with ingestion, orchestration, and ELT/ETL templates for cloud and on-prem sources.",
          "to": "/jumpstart/pipelines",
          "cta": "See Patterns",
          "tone": "purple",
          "icon": "Database"
        },
        {
          "title": "Models & Dashboards",
          "description": "Reusable semantic models and dashboard blueprints to accelerate build time and promote consistency.",
          "to": "/jumpstart/dashboards",
          "cta": "Open Gallery",
          "tone": "amber",
          "icon": "BarChart3"
        },
        {
          "title": "AI & Advanced Analytics",
          "description": "Pilot use cases like forecasting, anomaly detection, and copilots—grounded in governed datasets.",
          "to": "/jumpstart/ai",
          "cta": "Explore Pilots",
          "tone": "purple",
          "icon": "BrainCircuit"
        },
        {
          "title": "Governance & Quality",
          "description": "Lightweight guardrails for access, lineage, data contracts, and CI/CD for analytics assets.",
          "to": "/jumpstart/governance",
          "cta": "Read Guidelines",
          "tone": "teal",
          "icon": "Shield"
        },
        {
          "title": "Enablement & Handover",
          "description": "Runbooks, documentation, and office hours so client teams can sustain and scale after the JumpStart.",
          "to": "/jumpstart/enablement",
          "cta": "What You Get",
          "tone": "blue",
          "icon": "BookMarked"
        }
      ]
    }
  },
  "members": {
    "title": "Members",
    "description": "Meet the team. Each card shows a member’s role, skills, and projects.",
    "list": [
      {
        "name": "Nathanael Jhonn R Aguas",
        "role": "Service Consultant",
        "language": [
          "Python",
          "SQL",
          "JavaScript"
        ],
        "skill": [
          "Classification Models",
          "Document Handling"
        ],
        "assigned_projects": [
          "New Project 1",
          "New Project 2"
        ],
        "past_projects": [
          "Project1",
          "Project2",
          "Project3",
          "Project4",
          "Project5",
          "Project2",
          "Project3",
          "Project4",
          "Project2",
          "Project3",
          "Project4",
          "Project5",
          "Project2",
          "Project3",
          "Project4"
        ],
        "isActive": true
      },
      {
        "name": "John Michael M Batula",
        "role": "Service Consultant",
        "language": [
          "Python"
        ],
        "skill": [],
        "assigned_projects": [
          "New Project 1"
        ],
        "past_projects": [
          "Project1",
          "Project2"
        ],
        "isActive": true
      },
      {
        "name": "Edmichael Joil D Fajardo",
        "role": "Principal Consultant",
        "language": [
          "Python"
        ],
        "skill": [
          "Computer Vision",
          "Document Handling",
          "Tme-Series Forecasting"
        ],
        "assigned_projects": [
          "New Project 1",
          "New Project 2"
        ],
        "past_projects": [
          "Project3",
          "Project4"
        ],
        "isActive": true
      },
      {
        "name": "Samuel L Oronos",
        "role": "Service Consultant",
        "language": [
          "Python",
          "C#",
          "RPA",
          "VBA"
        ],
        "skill": [
          "PowerAutomate",
          "BluePrism",
          "PowerBI",
          "Automation Anywhere",
          "UIPATH",
          "Infrastructure",
          "Deployment",
          "Data Analytics"
        ],
        "assigned_projects": [
          "New Project 2"
        ],
        "isActive": true
      },
      {
        "name": "Reyner Mark D Halili",
        "role": "Service Consultant",
        "language": [
          "SQL",
          "VBA",
          "VB"
        ],
        "skill": [
          "PowerAutomate",
          "Data Analytics",
          "Automation Anywhere",
          "UIPATH",
          "Business Intelligence"
        ],
        "isActive": true
      },
      {
        "name": "Andrea Yna M Madarang",
        "role": "Service Consultant",
        "language": [
          "Python"
        ],
        "skill": [
          "Business Intelligence",
          "Data Analytics"
        ],
        "isActive": true
      },
      {
        "name": "Ramher N Pangindian",
        "role": "Principal Consultant",
        "language": [],
        "skill": [
          "Business Intelligence",
          "PowerBI"
        ],
        "isActive": true
      },
      {
        "name": "Jennie Lyn C Batas",
        "role": "Principal Consultant",
        "language": [
          "Python",
          "C#",
          "TypeScript",
          "Java",
          "SQL",
          "RPA"
        ],
        "skill": [
          "Full Stack",
          "PowerBI",
          "BluePrism",
          "Business Intelligence",
          "API Creation",
          "API Integration",
          "PowerAutomate",
          "QA Testing (Manual)",
          "Web Development",
          "Automation Anywhere",
          "UIPATH",
          "RAG Models"
        ],
        "isActive": true
      },
      {
        "name": "Rosuello Vincent A Legaspi",
        "role": "Associate Consultant",
        "language": [
          "Python",
          "Java",
          "PHP",
          "TypeScript",
          "JavaScript",
          "Angular",
          "NodeJS",
          "ReactJS"
        ],
        "skill": [
          "Full Stack",
          "Web Development",
          "NLP",
          "LLM Implementation"
        ],
        "isActive": true
      },
      {
        "name": "Maria Katrina J Varquez",
        "role": "Service Consultant",
        "language": [
          "PowerShell",
          "Python",
          "SQL",
          "RPA",
          "C#",
          "JavaScript",
          "VBA"
        ],
        "skill": [
          "PowerAutomate",
          "BluePrism"
        ],
        "isActive": true
      },
      {
        "name": "Alec Justin Rodriguez",
        "role": "Service Consultant",
        "language": [
          "TypeScript"
        ],
        "skill": [
          "Front End Development",
          "Back End Development",
          "Web Development",
          "Full Stack"
        ],
        "isActive": true
      },
      {
        "name": "Kenji A Kotani",
        "role": "Junior Consultant",
        "language": [
          "Python",
          "TypeScript",
          "C#",
          "Java",
          "PHP"
        ],
        "skill": [
          "Full Stack",
          "Web Development",
          "Regression Models",
          "Classification Models",
          "LLM Implementation"
        ],
        "isActive": true
      },
      {
        "name": "Samuel Allen L Gelacio",
        "role": "Service Consultant",
        "language": [
          "Python",
          "PHP",
          "ReactJS",
          "PBI",
          "WordPress",
          "Wix",
          "Java",
          "TypeScript",
          "SQL",
          "JavaScript",
          "C++",
          "Angular",
          "NodeJS",
          "HTML",
          "CSS",
          "React Native"
        ],
        "skill": [
          "PowerBI",
          "PowerPages",
          "Web Development",
          "Front End Development",
          "Back End Development"
        ],
        "isActive": true
      },
      {
        "name": "Mark Gerald P Giba",
        "role": "Junior Consultant",
        "language": [
          "Python"
        ],
        "skill": [
          "NLP",
          "Document Handling",
          "Classification Models",
          "Computer Vision"
        ],
        "isActive": true
      },
      {
        "name": "Jewel Anne B Panela",
        "role": "Junior Consultant",
        "language": [
          "Python",
          "SQL",
          "C++",
          "Kotlin",
          "Java"
        ],
        "skill": [
          "Back End Development",
          "NLP",
          "Classification Models"
        ],
        "isActive": true
      },
      {
        "name": "Phoebe Kelly C Liwanag",
        "role": "Junior Consultant",
        "language": [
          "Python",
          "HTML",
          "Java"
        ],
        "skill": [
          "API Integration",
          "Tme-Series Forecasting"
        ],
        "isActive": true
      },
      {
        "name": "Karth Ian P Macalalad",
        "role": "Principal Consultant",
        "language": [
          "Python"
        ],
        "skill": [
          "Deployment",
          "NLP",
          "RAG Models",
          "Tme-Series Forecasting",
          "Classification Models",
          "Clustering Models",
          "Regression Models",
          "LLM Implementation"
        ],
        "isActive": true
      },
      {
        "name": "John Marie L Naidas",
        "role": "Principal Consultant",
        "language": [
          "Python",
          "C#",
          "JavaScript",
          "HTML",
          "SQL",
          "NodeJS",
          "CSS",
          "ReactJS"
        ],
        "skill": [
          "Infrastructure",
          "Deployment",
          "Full Stack",
          "PowerBI",
          "Business Intelligence",
          "Web Development"
        ],
        "isActive": true
      },
      {
        "name": "Ruth R Morallos",
        "role": "Junior Consultant",
        "language": [
          "Python",
          "Java",
          "TypeScript",
          "SQL",
          "JavaScript"
        ],
        "skill": [
          "Full Stack",
          "QA Testing (Manual)",
          "QA Testing (Automated)",
          "NLP",
          "Document Handling",
          "Web Development",
          "Data Analytics",
          "Classification Models",
          "Clustering Models",
          "AI/ML Model Training"
        ],
        "isActive": true
      },
      {
        "name": "Angelica P Ware",
        "role": "Service Consultant",
        "language": [
          "Angular",
          "HTML",
          "CSS",
          "JavaScript",
          "TypeScript",
          "ReactJS",
          "Kotlin",
          "PowerShell"
        ],
        "skill": [
          "UI/UX",
          "Web Development",
          "PowerApps",
          "Front End Development",
          "Figma"
        ],
        "isActive": false
      },
      {
        "name": "Genrev Kiel A Hizon",
        "role": "Service Consultant",
        "language": [
          "Python"
        ],
        "skill": [
          "Classification Models",
          "Regression Models",
          "LLM Implementation",
          "NLP",
          "Computer Vision",
          "API Creation",
          "PowerBI",
          "Data Analytics"
        ],
        "isActive": true
      },
      {
        "name": "Charles Erickson B Alcordo",
        "role": "Principal Consultant",
        "language": [
          "C#",
          "TypeScript",
          "SQL",
          "JavaScript",
          "VB"
        ],
        "skill": [
          "Full Stack",
          "API Integration",
          "API Creation",
          "Web Development",
          "Front End Development",
          "Deployment",
          "Back End Development"
        ],
        "isActive": true
      },
      {
        "name": "Hannah Franchette Laxa",
        "role": "Lead Consultant",
        "language": [
          "Flutter Dart",
          "JavaScript",
          "HTML",
          "PHP",
          "TypeScript",
          "Python",
          "VB Macro",
          "SQL"
        ],
        "skill": [
          "Web Development",
          "Front End Development",
          "Agile Methodology",
          "Back End Development",
          "Scrum",
          "OpenShift Deployment",
          "Containerization",
          "Docker",
          "Full Stack",
          "API Creation",
          "Deployment"
        ],
        "isActive": true
      },
      {
        "name": "Marianne Nicole L Zulueta",
        "role": "Junior Consultant",
        "language": [],
        "skill": [],
        "isActive": true
      },
      {
        "name": "Beatrice Micaela G Ramirez",
        "role": "",
        "language": [
          "Python",
          "Java",
          "PHP",
          "SQL",
          "RPA",
          "JavaScript",
          "HTML",
          "CSS",
          "PBI"
        ],
        "skill": [
          "Web Development",
          "Front End Development",
          "UIPATH",
          "Back End Development",
          "PowerBI"
        ],
        "isActive": true
      },
      {
        "name": "Jacqueline Cate S Catley",
        "role": "Service Consultant",
        "language": [
          "Python",
          "C++",
          "TypeScript",
          "HTML",
          "CSS",
          "C"
        ],
        "skill": [
          "Computer Vision",
          "NLP",
          "Classification Models",
          "Front End Development"
        ],
        "isActive": false
      },
      {
        "name": "Gerardo Jr. D Eslabra",
        "role": "Service Consultant",
        "language": [
          "RPA",
          "VBA",
          "HTML",
          "VB Macro",
          "PBI"
        ],
        "skill": [
          "BluePrism",
          "PowerBI",
          "UIPATH"
        ],
        "isActive": true
      },
      {
        "name": "Frank P Katada Jr.",
        "role": "Manager Consulting Expert",
        "language": [
          "Python",
          "TypeScript",
          "ReactJS",
          "NodeJS",
          "PowerShell",
          "PBI",
          "JavaScript",
          "SQL",
          "C#"
        ],
        "skill": [],
        "isActive": true
      }
    ]
  },
  "contactUs": {
    "title": "Contact Us",
    "description": "Get in touch with the ITS team.",
    "form": {
      "title": "Send a message",
      "description": "Tell us about your project or question. We typically reply within one business day.",
      "requiredText": "Fields marked with * are required.",
      "emailTo": "ph.sm.gen.digitalization.and.automation.services.pmo@cgi.com",
      "fields": [
        {
          "name": "fullName",
          "label": "Full name",
          "type": "text",
          "required": true,
          "width": "half"
        },
        {
          "name": "email",
          "label": "Work email",
          "type": "email",
          "required": true,
          "width": "half"
        },
        {
          "name": "company",
          "label": "Company",
          "type": "text",
          "required": false,
          "width": "half"
        },
        {
          "name": "subject",
          "label": "Subject",
          "type": "text",
          "required": true,
          "width": "half"
        },
        {
          "name": "reason",
          "label": "Select a reason",
          "type": "select",
          "required": false,
          "width": "full",
          "options": [
            {
              "value": "",
              "label": "Select a reason…"
            },
            {
              "value": "discovery",
              "label": "Project discovery"
            },
            {
              "value": "staffing",
              "label": "Resource availability"
            },
            {
              "value": "analytics",
              "label": "Analytics & BI"
            },
            {
              "value": "governance",
              "label": "Advisory & governance"
            },
            {
              "value": "other",
              "label": "Other"
            }
          ]
        },
        {
          "name": "message",
          "label": "Tell us a bit about your use case, timelines, and any context ....",
          "type": "textarea",
          "required": false,
          "width": "full"
        }
      ],
      "checkbox": {
        "label": "I agree to be contacted about this inquiry and related services.",
        "required": true
      },
      "submitLabel": "Send message"
    }
  }
}